'use client';
import { Fragment } from 'react';
import Container from '@mui/material/Container';
import Footer from '@/components/footer';
import SignupBanner from './signup-banner';

type Props = {
  children?: React.ReactNode;
  compact?: boolean;
  signupBanner?: boolean;
  bannerDismissed?: boolean;
};

const Main = ({ children, compact = false, signupBanner = false, bannerDismissed = false }: Props) => {
  return (
    <Fragment>
      {signupBanner && !bannerDismissed && <SignupBanner />}
      <Container
        maxWidth={false}
        component="div"
        sx={(theme) => ({
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
          [theme.breakpoints.down('sm')]: {
            margin: 0,
          },
        })}
      >
        <main>
          {compact ? (
            <Container maxWidth="md" disableGutters>
              {children}
            </Container>
          ) : (
            children
          )}
        </main>

        <Footer />
      </Container>
    </Fragment>
  );
};

export default Main;
